import {Component, Input} from '@angular/core';

@Component({
    selector: 'ac-progress',
    templateUrl: './ac-progress.component.html',
    styleUrls: ['./ac-progress.component.less'],
})

export class AcProgressComponent {

    @Input() center = true;
    private readonly SMALL_PATH = 'assets/loading.gif';
    private readonly LARGE_PATH = 'assets/loading_2x.gif';
    public path = this.LARGE_PATH;

    @Input() set small(small) {
        if (small) {
            this.path = this.SMALL_PATH;
        } else {
            this.path = this.LARGE_PATH;
        }
    }
}



